import { Injectable } from '@angular/core';
import { KeyValueStorage } from './key-value-storage';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService implements KeyValueStorage {
  set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }
  get(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }
}
